import React from "react";
import styled from "styled-components";

import { Label, Input as BootstrapInput } from "reactstrap";

const Checkbox = props => {
  return (
    <BootstrapInput
      type="checkbox"
      className="custom-control-input"
      {...props}
    />
  );
};

const renderCheckbox = ({ input, meta, label, ...props }) => {
  const showError = meta.touched && meta.error;
  return (
    <div>
      <Label className="custom-control custom-checkbox align-items-center flex-wrap">
        <Checkbox {...input} {...props} valid={showError ? false : undefined} />
        <span className="custom-control-indicator" />
        <StyledText className="custom-control-description">{label}</StyledText>
      </Label>
      {showError && <Error>{meta.error}</Error>}
    </div>
  );
};

const Error = styled.div.attrs({ className: "text-danger" })`
  width: 100%;
  font-size: 12px;
  margin-bottom: 20px;
`;
const StyledText = styled.span.attrs({
  className: "text-dark"
})`
  font-size: 12px;
  font-weight: 300;
`;

export { Checkbox, renderCheckbox };



// WEBPACK FOOTER //
// ./src/components/Form/Checkbox.js